import A from '../api/apiconstants';
import { callGet, callPost } from '../api/api';
import { parse } from 'date-fns';
import { setClientSecret, setPaymentIntentId, setPaymentIntentAmount, setBookings, setPage } from './AppSlice';
import { saveAvailability } from '../database/database';

const updateAvailability = (dispatch, getState) => {

    const { bookingDetails, bookings } = getState().appState;

    let updatedBookings = JSON.parse(JSON.stringify(bookings)); 

    let date = parse(bookingDetails.arrivalDate, 'yyyyMMdd', new Date());

    let noOfNights = bookingDetails.duration;

    console.log("Date of booking: " + date);
    console.log("Duration: " + noOfNights);

    if (updatedBookings != null) {
      console.log("bookings is not null");
      let thisYear = date.getFullYear();
      let thisYearPlusOne = thisYear+1;
      let year = 'year' + thisYear;
      let nextYear = 'year' + thisYearPlusOne;
      let month = date.getMonth();
      let day = date.getDate();
      let nightsBooked = 0;

      switch (month) {
        case 0:
          for (let i = day; (i < day + noOfNights && i <= 31); i++) {
            nightsBooked++;
            updatedBookings[year].january[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].february[i-1] = true;
            }  
          }
          break;
        case 1:
          for (let i = day; (i < day + noOfNights && i <= 28); i++) {
            nightsBooked++;
            updatedBookings[year].february[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].march[i-1] = true;
            }  
          }
          break;
        case 2:
          for (let i = day; (i < day + noOfNights && i <= 31); i++) {
            nightsBooked++;
            updatedBookings[year].march[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].april[i-1] = true;
            }  
          }
          break;
        case 3:
          for (let i = day; (i < day + noOfNights && i <= 30); i++) {
            nightsBooked++;
            updatedBookings[year].april[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].may[i-1] = true;
            }  
          }
          break;
        case 4:
          for (let i = day; (i < day + noOfNights && i <= 31); i++) {
            nightsBooked++;
            updatedBookings[year].may[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].june[i-1] = true;
            }  
          }
          break;
        case 5:
          for (let i = day; (i < day + noOfNights && i <= 30); i++) {
            nightsBooked++;
            updatedBookings[year].june[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].july[i-1] = true;
            }  
          }
          break;
        case 6:
          for (let i = day; (i < day + noOfNights && i <= 31); i++) {
            nightsBooked++;
            updatedBookings[year].july[i-1] = true;
          }

          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].august[i-1] = true;
            }  
          }
          break;
        case 7:
          for (let i = day; (i < day + noOfNights && i <= 31); i++) {
            nightsBooked++;
            updatedBookings[year].august[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].september[i-1] = true;
            }  
          }
          break;
        case 8:
          for (let i = day; (i < day + noOfNights && i <= 30); i++) {
            nightsBooked++;
            updatedBookings[year].september[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].october[i-1] = true;
            }  
          }
          break;
        case 9:
          for (let i = day; (i < day + noOfNights && i <= 31); i++) {
            nightsBooked++;
            updatedBookings[year].october[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].november[i-1] = true;
            }  
          }
          break;
        case 10:
          for (let i = day; (i < day + noOfNights && i <= 30); i++) {
            nightsBooked++;
            updatedBookings[year].november[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[year].december[i-1] = true;
            }  
          }
          break;
        case 11:
          for (let i = day; (i < day + noOfNights && i <= 31); i++) {
            nightsBooked++;
            updatedBookings[year].december[i-1] = true;
          }
          if (nightsBooked < noOfNights) {
            for (let i = 1; (i <= noOfNights - nightsBooked); i++) {
              updatedBookings[nextYear].january[i-1] = true;
            }  
          }
          break;
      }
    }
    dispatch(setBookings(updatedBookings));

    // Now book the dates on the database
    saveAvailability(updatedBookings).then(() => {
      console.log("All dates booked in database!!");
    });


  }

export const bookAppointment = (data) => {
//    const apiUrl = "http://localhost:9081/BookingService/v1/book";
    const apiUrl = "https://booking-service-geokyuazkq-nw.a.run.app/BookingService/v1/book";
    return callPost(apiUrl, data).then((response) => {
        if (response.status === A.OK) {
            console.log("Appointment booked successfully");
        } else {
            console.log("An error ocurred booking the appointment: " + response.status);
        }
    });
}

export const getPaymentIntent = (data) => {
//    const apiUrl = "http://localhost:9081/BookingService/v1/create-payment-intent";
    const apiUrl = "https://booking-service-geokyuazkq-nw.a.run.app/BookingService/v1/create-payment-intent";
    return (dispatch) => {
        return callPost(apiUrl, data).then((response) => {
            if (response.status === A.OK) {
                if (response.data && response.data.clientSecret && response.data.paymentIntentId) {
                    dispatch(setClientSecret(response.data.clientSecret));
                    dispatch(setPaymentIntentId(response.data.paymentIntentId))

                    if (data.item.amount) {
                        dispatch(setPaymentIntentAmount(data.item.amount))
                    }
                }
                console.log("Payment Intent created successfully");
            } else {
                console.log("An error ocurred creating the payment intent: " + response.status);
            }
        });
    }
}

export const updateElement = (elements) => {
    console.log("Elements: " + elements);
    return (dispatch) => {
        return elements.fetchUpdates().then((result) => {
            if (result.error) {
                console.log("Elements update failed");
            }
         });
    }
}

export const retrievePaymentIntent = (data) => {
    //    const apiUrl = "http://localhost:9081/BookingService/v1/retrieve-payment-intent/" + data;
        const apiUrl = "https://booking-service-geokyuazkq-nw.a.run.app/BookingService/v1/retrieve-payment-intent/" + data;
        return (dispatch, getState) => {
            return callGet(apiUrl, data).then((response) => {
                // If the Stripe payment has been made then it will redirect back to the /success path
                // Then retrieve payment intent will be called
                // If the payment is for the same amount as expected then book the appointment
                if (response.status === A.OK) {
                    console.log("Payment Intent retrieved successfully");
                    console.log("Payment intent amount: " + response.data);

                    if ((response.data &&
                         getState().appState.bookingDetails &&
                         getState().appState.bookingDetails.audit)) {
                            let savedPaymentAmount = getState().appState.bookingDetails.audit.paidToDate*100;
                            console.log("Payment intent amount to check: " + response.data);
                            console.log("Booking payment amount to check: " + savedPaymentAmount);
                            if (response.data === savedPaymentAmount) {
                              console.log("Correct payment processed successfully.  The booking can now be saved.")
                              bookAppointment(getState().appState.bookingDetails);
                              updateAvailability(dispatch, getState);
                              dispatch(setPage("PAYMENT_SUCCESS"));
                            } else {
                              dispatch(setPage("BOOKING_ERROR"));
                            }       
                    } else {
                        dispatch(setPage("BOOKING_ERROR"));
                    }
                } else {
                    console.log("An error ocurred retrieving the payment intent: " + response.status);
                    dispatch(setPage("BOOKING_ERROR"));
                }
            });
        }
    }
    

export const pingServer = () => {
//    const apiUrl = "http://localhost:9081/BookingService/v1/hello";
    const apiUrl = "https://booking-service-geokyuazkq-nw.a.run.app/BookingService/v1/hello";
    return (dispatch) => {
      return callGet(apiUrl).then((response) => {
      if (response.status === A.OK) {
//          console.log("Ping successful");
      }   else {
          console.log("An error ocurred during the ping: " + response.status);
      }
    });
  }
}